var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "[ c-island c-island--large@lg ] t-background-white-grey t-margin-bottom-s"
    },
    [
      _c("h2", { staticClass: "t-text-style-beta" }, [
        _vm._v("Grunduppgifter")
      ]),
      _vm._v(" "),
      _vm.dataMode === "view"
        ? [
            _c("div", { staticClass: "t-background-white-grey" }, [
              _c(
                "div",
                {
                  staticClass:
                    "c-island t-margin-top-s  t-margin-bottom-s  t-background-white"
                },
                [
                  _c("div", { staticClass: "o-grid o-grid--no-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "s:12 sm:11" }
                      },
                      [
                        _c("div", { staticClass: "o-grid" }, [
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Namn")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.firstName) +
                                          " " +
                                          _vm._s(_vm.surName)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Personnummer")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [_vm._v(_vm._s(_vm.personalIdentityNumber))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Anställningsnummer")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [_vm._v(_vm._s(_vm.employeeNumber))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Anställningsdatum")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.employmentDate
                                            ? _vm.formatDate(_vm.employmentDate)
                                            : ""
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Email")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [_vm._v(_vm._s(_vm.email))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Roll")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [_vm._v(_vm._s(_vm.role))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Körkortsklass")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [_vm._v(_vm._s(_vm.drivingLicense))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:4 lg:4" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Arbetsställe")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-basic-information__content"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.workplace &&
                                            _vm.workplace.attributes
                                            ? _vm.workplace.attributes.name
                                            : ""
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "s:12 sm:12" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-basic-information__wrapper t-margin-bottom-s"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Grundutbildning, examensår")]
                                  ),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass:
                                      "c-basic-information__content s-text",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.education)
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "s:12 sm:12" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-basic-information__wrapper" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-basic-information__label"
                                    },
                                    [_vm._v("Erfarenhet")]
                                  ),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass:
                                      "c-basic-information__content s-text t-margin-bottom-none",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.experience)
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "o-grid__column  t-text-align-right  t-margin-top-s@s",
                        attrs: { "data-size": "s:12 sm:1" }
                      },
                      [
                        _vm.$can("manage", "CompetenceCard")
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset",
                                attrs: { type: "button" },
                                on: { click: _vm.goToEditMode }
                              },
                              [_vm._v("Ändra")]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ]
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.dataMode === "create" || _vm.dataMode === "edit"
        ? [
            _c(
              "form",
              {
                staticClass: "c-form  t-margin-top-s",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.handleSubmit($event)
                  }
                }
              },
              [
                _c("fieldset", [
                  _c("div", { staticClass: "o-grid" }, [
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "firstName",
                              attrs: {
                                label: "Förnamn",
                                "input-id": "firstName",
                                value: _vm.firstName
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "surName",
                              attrs: {
                                label: "Efternamn",
                                "input-id": "surName",
                                value: _vm.surName
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("personal-identity-number-input", {
                              ref: "personalIdentityNumber",
                              attrs: {
                                label: "Personnummer (ååmmdd-nnnn)",
                                "input-id": "personalIdentityNumber",
                                value: _vm.personalIdentityNumber,
                                required: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "employeeNumber",
                              attrs: {
                                label: "Anställningsnummer",
                                "input-id": "employeeNumber",
                                value: _vm.employeeNumber,
                                required: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("date-input", {
                              ref: "employmentDate",
                              attrs: {
                                label: "Anställningsdatum (åååå-mm-dd)",
                                "input-id": "employmentDate",
                                value: _vm.employmentDate,
                                required: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "email",
                              attrs: {
                                type: "email",
                                label: "Email",
                                "input-id": "email",
                                value: _vm.email
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "role",
                              attrs: {
                                label: "Roll",
                                "input-id": "role",
                                value: _vm.role,
                                required: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:6 lg:6" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "drivingLicense",
                              attrs: {
                                label: "Körkortsklass",
                                "input-id": "drivingLicense",
                                value: _vm.drivingLicense,
                                required: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:12 lg:12" }
                      },
                      [
                        _c("dropdown-variations", {
                          ref: "workplace",
                          attrs: {
                            label: "Välj arbetsställe",
                            "item-groups": _vm.workplaceOptions,
                            value: {
                              id: _vm.workplace ? _vm.workplace.id : "",
                              name:
                                _vm.workplace && _vm.workplace.attributes
                                  ? _vm.workplace.attributes.name
                                  : ""
                            },
                            disabled: _vm.dataMode === "edit",
                            filterable: true
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column t-margin-top-s",
                        attrs: { "data-size": "sm:12 md:12 lg:12" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "education",
                              attrs: {
                                label: "Grundutbildning, examensår",
                                "input-id": "education",
                                value: _vm.education,
                                type: "textarea",
                                required: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:12 lg:12" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "c-form__item" },
                          [
                            _c("vue-input", {
                              ref: "experience",
                              attrs: {
                                label: "Erfarenhet",
                                "input-id": "experience",
                                value: _vm.experience,
                                type: "textarea",
                                required: false
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "o-grid__column",
                        attrs: { "data-size": "sm:12 md:12 lg:12" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "t-margin-bottom-xs t-margin-top-xs t-text-align-right"
                          },
                          [
                            _vm.dataMode === "create"
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "c-button c-button--linkstyle c-button--reset",
                                    attrs: { to: "/" }
                                  },
                                  [_vm._v("Avbryt")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataMode === "create"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "c-button c-button--primary",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSubmitType("create")
                                      }
                                    }
                                  },
                                  [_vm._v("Spara")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataMode === "edit"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "c-button c-button--linkstyle c-button--reset",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.cancelEditCompetenceCard(
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Avbryt")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataMode === "edit"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "c-button c-button--primary",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSubmitType("edit")
                                      }
                                    }
                                  },
                                  [_vm._v("Spara")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }